export type PlayerKitMeta = {
  number: number;
  kitColor: string;
  trimColor?: string;
  countryCode?: string;
};

export const TOP_SCORERS = [
  'Kylian Mbappé',
  'Erling Haaland',
  'Viktor Gyökeres',
  'Vinicius',
  'Harry Kane',
  'Bukayo Saka',
  'Lamine Yamal',
  'Rodri',
  'Pedri',
] as const;

export const PLAYER_INFO: Record<string, PlayerKitMeta> = {
  'Kylian Mbappé': { number: 10, kitColor: '#1E3A8A', trimColor: '#C8102E', countryCode: 'fr' },
  'Erling Haaland': { number: 9, kitColor: '#BA0C2F', trimColor: '#00205B', countryCode: 'no' },
  'Viktor Gyökeres': { number: 9, kitColor: '#EAB308', trimColor: '#1D4ED8', countryCode: 'se' },
  Vinicius: { number: 7, kitColor: '#FACC15', trimColor: '#166534', countryCode: 'br' },
  'Vinicius Jr.': { number: 7, kitColor: '#FACC15', trimColor: '#166534', countryCode: 'br' },
  'Harry Kane': { number: 9, kitColor: '#F5F5F5', trimColor: '#BE123C', countryCode: 'gb-eng' },
  'Bukayo Saka': { number: 7, kitColor: '#CC0000', trimColor: '#FFFFFF', countryCode: 'gb-eng' },
  'Lamine Yamal': { number: 19, kitColor: '#C8102E', trimColor: '#F1C40F', countryCode: 'es' },
  'Rodri': { number: 16, kitColor: '#C8102E', trimColor: '#F1C40F', countryCode: 'es' },
  'Pedri': { number: 8, kitColor: '#C8102E', trimColor: '#F1C40F', countryCode: 'es' },
};
